import { Avatar, Box, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";

export const HeaderComp = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    gap: '12px',
    direction: 'ltr',
    alignItems: 'start',

}))
export const HeaderTextComp = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    gap: '8px',
    alignItems: 'start',
    flexDirection: 'column'
}))
export const HeaderText = styled(Typography)(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    color: theme.palette.mode === "light" ?
        theme.palette.text.lightSecondary :
        theme.palette.text.darkSecondary,
    margin: '0',
    [theme.breakpoints.down('sm')]: {
        fontSize: "16px",
        fontWeight: "600",
    }
}))
export const HeaderTextSecondary = styled(Typography)(({ theme }) => (props) => ({
    fontSize: "20",
    fontWeight: "400",
    color: theme.palette.mode === "light" ?
        theme.palette.text.light :
        theme.palette.text.dark,
    [theme.breakpoints.down('sm')]: {
        fontSize: "14px",
        fontWeight: "400",
    }
}))
export const LinkIcon = styled(Link)(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px'
}))
export const ImageArrow = styled(Avatar)(({ theme }) => (props) => ({
    width: '18px',
    height: '18px',
    borderRadius: '50%'
}))